import moment from "moment";

/**
 * Data ausente nao e data valida (#4123).
 *
 * `moment(undefined)` e o mesmo que `moment()`: devolve AGORA e responde
 * `isValid() === true`. Como os formatadores so perguntavam "e valido?", campo
 * que o backend nao enviou virava o horario em que a tela carregou — e igual em
 * todas as linhas. Mostrar a hora atual no lugar de "nunca aconteceu" e pior
 * que mostrar vazio: parece dado de verdade.
 */
const semData = (valor) => valor === undefined || valor === null || valor === "";

export function useDate() {
  function dateToClient(strDate) {
    if (semData(strDate)) return "";
    if (moment(strDate).isValid()) {
      return moment(strDate).format("DD/MM/YYYY");
    }
    return strDate;
  }

  function datetimeToClient(strDate) {
    if (semData(strDate)) return "";
    if (moment(strDate).isValid()) {
      return moment(strDate).format("DD/MM/YYYY HH:mm");
    }
    return strDate;
  }

  function dateToDatabase(strDate) {
    if (moment(strDate, "DD/MM/YYYY").isValid()) {
      return moment(strDate).format("YYYY-MM-DD HH:mm:ss");
    }
    return strDate;
  }

  function returnDays(date) {
    let data1 = new Date()
    let data2 = new Date(date)
    let result = data2.getTime() - data1.getTime();
    let days = Math.ceil(result / (1000 * 60 * 60 * 24));

    if (days === -0) {
      days = 0
    }
    return days;
  }

  return {
    dateToClient,
    datetimeToClient,
    dateToDatabase,
    returnDays
  };
}
